
























































































































































































































































































import {Component} from 'vue-property-decorator';
import Vue from 'vue';
import {Action, State} from 'vuex-class';
import {RegisterEnum} from '@/store/auth/auth.enum';
import {
  Company,
  Education,
  Member, MemberInitState,
  MemberService,
  MemberServiceFreeTime,
  PersonEmergencies
} from '@/store/member/member.types';
import {Branch, BranchInitState} from '@/store/branch/branch.types';
import {MemberDurationStatus, MemberServiceType, MemberStatus, MemberTypes} from '@/store/member/member.enum';
import {FormValidate} from '@/services/form-validate';
import {Toast} from '@/store/toast/toast.types';
import {Community, CommunityInitState, FilterCommunity} from '@/store/community/community.types';
import AddressCurrentComponent from '@/components/register/AddressCurrent.vue';
import AddressPermanentComponent from '@/components/register/AddressPermanent.vue';
import AddressEmergenciesComponent from '@/components/register/AddressEmergencies.vue';
import BgThemePublic from '@/components/bg-theme-public.vue';
import 'vue-select/dist/vue-select.css';


@Component({
  components: {
    AddressCurrentComponent,
    AddressPermanentComponent,
    AddressEmergenciesComponent,
    BgThemePublic
  }
})
export default class SteppersOneComponent extends Vue {

  @State('branch') branchInitState!: BranchInitState;
  @State('member') memberState!: MemberInitState;
  @State('community') communityInitState!: CommunityInitState;
  @Action('_Loading', {namespace: 'loading'}) Loading!: (payload: boolean) => Promise<void>;
  @Action('_Toast', {namespace: 'toast'}) Toast!: (payload: Toast) => Promise<void>;
  @Action('_getBranchForRegister', {namespace: 'branch'}) getBranchForRegister!: () => Promise<void>;
  @Action('_getCheckMobilePhone', {namespace: 'member'}) getCheckMobilePhone!: (payload: string) => Promise<number>;
  @Action('_getCommunityForRegister', {namespace: 'community'}) getCommunityForRegister!: (payload: FilterCommunity) => Promise<void>;
  @Action('_getBondsmanByBranchIdForRegister', {namespace: 'member'}) getBondsmanByBranchIdForRegister!: () => Promise<void>;

  uuIDV4 = require('uuid/v4');
  public memberList = [{}] as [
    {
      id: string;
      fullName: string,
      phone: string;
    }
  ];
  public branchList = [{id: ''}] as Branch[];
  public communityList = [{id: ''}] as Community[];
  public showpassword = true;
  public isReady = false;
  public title = [
    {value: 'นาย'},
    {value: 'นาง'},
    {value: 'นางสาว'},
    {value: 'ด.ช.'},
    {value: 'ด.ญ.'},
    {value: 'อื่นๆ'}
  ];
  public gender = [
    {text: 'ชาย', value: 'male'},
    {text: 'หญิง', value: 'female'}
  ];
  public MemberData = {
    id: this.uuIDV4(),
    // title: '',
    branchId: '',
    communityId: '',
    gender: '',
    currentProvinces: '',
    currentAmphures: '',
    currentDistricts: '',
    // permanentAddress: '',
    // permanentProvinces: '',
    // permanentAmphures: '',
    // permanentDistricts: '',
    otherService: {},
    memberType: MemberTypes.Normal,
    memberStatus: MemberStatus.Pending,
    memberDurationStatus: MemberDurationStatus.Normal,
    personEmergencies: [] as PersonEmergencies[],
    // educations: [{} as Education] as Education[],
    // companies: [{} as Company] as Company[],
    memberServices: [
      {
        subServiceId: '',
        serviceId: '',
        memberServiceType: MemberServiceType.ServiceProvider,
        crossBranch: false,
        memberServiceFreeTimes: [
          {freeDay: '1', use: false},
          {freeDay: '2', use: false},
          {freeDay: '3', use: false},
          {freeDay: '4', use: false},
          {freeDay: '5', use: false},
          {freeDay: '6', use: false},
          {freeDay: '7', use: false},
        ] as MemberServiceFreeTime[]
      } as MemberService,
      {
        subServiceId: '',
        serviceId: '',
        memberServiceType: MemberServiceType.ServiceReceiver,
        crossBranch: false,
        memberServiceFreeTimes: [
          {freeDay: '1', use: false},
          {freeDay: '2', use: false},
          {freeDay: '3', use: false},
          {freeDay: '4', use: false},
          {freeDay: '5', use: false},
          {freeDay: '6', use: false},
          {freeDay: '7', use: false},
        ] as MemberServiceFreeTime[]
      } as MemberService
    ] as MemberService[],
    bondsmanId: '',
    education: '',
    weakPassword: false
  } as Member;


  async mounted() {
    await this.Loading(true);
    this.isReady = false;
    await this.getBranchForRegister();
    await this.getBondsmanByBranchIdForRegister();
    this.memberState.member.forEach((x) => {
          if (x.id) {
            this.memberList.push({
              fullName: `${x.firstName} ${x.lastName}`,
              phone: x.mobilePhone,
              id: x.id
            })
          }
        }
    )
    this.branchList = this.branchInitState.branchs;
    if (localStorage.getItem(RegisterEnum.Register) === null) {
      localStorage.setItem(RegisterEnum.Register, JSON.stringify(this.MemberData).toString());
    } else {
      this.MemberData = await JSON.parse(localStorage.getItem(RegisterEnum.Register) as string) as Member;
      await this.getCommunity();
    }
    this.isReady = true;
    this.Loading(false);
  }

  async SelBranch() {
    await this.getCommunity();
    this.ChangeData();
  }

  async getCommunity() {
    if (this.MemberData.branchId !== '') {
      await this.getCommunityForRegister({branchId: this.MemberData.branchId} as FilterCommunity);
      this.communityList = this.communityInitState.community;
    }
  }

  ChangeData() {
    localStorage.setItem(RegisterEnum.Register, JSON.stringify(this.MemberData).toString());
  }

  async CheckMobilePhone(e: { target: { value: string } }) {
    if (e.target.value.match(/^[0-9]+$/) !== null) {
      await this.getCheckMobilePhone(e.target.value);
      let CheckMobile = this.memberState.checkMobile;
      if (CheckMobile === 0) {
        this.MemberData.mobilePhone = e.target.value;
      } else {
        this.Toast({
          heading: 'หมายเลขโทรศัพท์นี้มีการลงทะเบียนไว้แล้ว',
          message: 'กรุณากรอกหมายเลขโทรศัพท์อีกครั้ง',
          type: 'danger'
        }).then();
        this.MemberData.mobilePhone = '';
      }
    } else {
      this.Toast({
        heading: 'กรุณากรอกข้อมูลใหม่',
        message: 'กรุณากรอกหมายเลขโทรศัพท์อีกครั้ง',
        type: 'danger'
      }).then();
      this.MemberData.mobilePhone = '';
    }
    this.ChangeData();
  }

  async ChangePassword(e: { target: { value: string } }) {
    if (e.target.value.match(/^[0-9]+$/) !== null) {
      this.ChangeData();
    } else {
      this.Toast({
        heading: 'กรุณากรอกรหัสผ่านใหม่',
        message: 'กรุณากรอกรหัสผ่านตัวเลข 6 หลัก',
        type: 'danger'
      }).then();
      this.MemberData.password = '';
    }
  }

  async actionAddressCurrent(current: any) {
    this.MemberData.currentAddress = current.currentAddress;
    this.MemberData.currentProvinces = current.currentProvinces;
    this.MemberData.currentAmphures = current.currentAmphures;
    this.MemberData.currentDistricts = current.currentDistricts;
    this.MemberData.currentZip = current.currentZip;
    this.ChangeData();
  }


  async stepOne() {
    let forms = document.getElementsByClassName('step-one');
    let valid = FormValidate.validate(forms);
    if (!valid) {
      this.Toast({
        heading: '!',
        message: 'กรุณากรอกข้อมูลตามที่กำหนด',
        type: 'danger'
      }).then();
      return;
    }
    await this.$router.push('/register-2');
  }

  async ChangeBondman() {
    if (this.MemberData.bondsmanId !== '') {
      let member = this.memberList.find((x) => x.id === this.MemberData.bondsmanId)
      if (member) {
        this.MemberData.bondsmanPhone = member.phone
      }
    }
    await this.ChangeData();
  }

  async actionSetEmergencies(emergencies : PersonEmergencies) {
    this.MemberData.personEmergencies = [emergencies];
    await this.ChangeData();
  }

}
